if (document.getElementsByClassName("sections-list").length > 0) {

    var h2Elements = $(".article-main-body h2").get();

    for (i = 0; i < h2Elements.length; i++) {
        var el = h2Elements[i];

        var title = $(el).text().trim();
        var slug = title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();

        el.id = slug;

        var liEl = $('<a class="sections-list__element" href="#' + slug + '">' +
            '<img alt="" class="sections-list__icon bouncy-icon" src="/Static/gfx/icons/subIcons/arrow-down.png" alt="" />' +
            '<span class="sections-list__header hover-header">' + title + '</span>' +
            "</a>");

        $(".sections-list").append(liEl);
    }

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        if ($target.length) {
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        }
    });
}